<template>
  <ImageManagement 
    folder-type="coaches" 
    :page-title="$t('imageManagement.coachImages')"
    :empty-text="$t('imageManagement.noImages')"
  />
</template>

<script setup>
import ImageManagement from './index.vue'
</script>
